import config from "../../../config/index";

const FilterButtons = (props) => {
  let sortData = props.sortData;
  const env = config.env;
	const imagePrefix = config.envConfigs[env].imagePrefix;
  const getSortLabel = () => {
    for (let i = 0; i < sortData.length; i++) {
      if (props.sortValue == sortData[i].id) {
        return sortData[i].name;
      }
    }
  };
  return (
    <>
      <button
        className="buy-bundle-container__filter top-filter"
        onClick={() => props.SetShowModal(true)}
        id={"filter-bundles-btn"}
      >
        {" "}
        <img
          className="button-image"
          src={`${imagePrefix}/assets/images/filter.svg`}
          alt="filter"
        />
        {"Filter bundles"} <i className="v-icon-caret-right right-arrow"></i>
      </button>
      <button
        onClick={() => props.setSortModal(true)}
        id={"sort-bundles-btn"}
        className="buy-bundle-container__filter"
      >
        <img className="button-image" src={`${imagePrefix}/assets/images/sort.svg`} alt="sort" />
        {"Sort by"}: <span className="button-text"> {getSortLabel()} </span>
        <i className="v-icon-caret-right right-arrow"></i>
      </button>
    </>
  );
};

export default FilterButtons;
